module.exports = __webpack_public_path__ + "static/img/banner-3.94c32a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-3.jpg
// module id = MkWj
// module chunks = 36